import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { documentCategory } from "./document-categories";
import { DocumentExampleList } from "./document-example-list";
import { type OnboardingDocumentType } from "./types";

const DOCUMENT_GUIDANCE_TITLE = "What to send";

const AskList = ({ asks }: { asks: readonly string[] }) => (
  <ul className="ml-4 list-disc space-y-2 marker:text-stroke-primary">
    {asks.map((ask) => (
      <li key={ask}>
        <Typography variant="bodyW2" textColor="secondary">
          {ask}
        </Typography>
      </li>
    ))}
  </ul>
);

const FORMAT_NOTE =
  "Send spreadsheets as files rather than printouts, so we can see the formulas. Photos of a printed plan are fine.";

// The reference material for the step they are on. One padded container rather than
// CardHeader plus CardContent, which stack their own padding and leave the title floating
// above what it introduces; and the examples sit at the top right, level with the title,
// so the card is as short as its content allows.
export const DocumentGuidance = ({
  type,
}: {
  type: OnboardingDocumentType;
}) => {
  const category = documentCategory(type);

  return (
    <Card className="w-full border-stroke-tertiary p-6 shadow-sm">
      <Stack
        direction="row"
        gap="xl"
        align="start"
        fullWidth
        className="flex-col sm:flex-row"
      >
        <Stack gap="md" align="stretch" className="min-w-0 flex-1">
          <Typography variant="subtitleW1">
            {DOCUMENT_GUIDANCE_TITLE}
          </Typography>
          <AskList asks={category.asks} />
          <Typography variant="captionW1" textColor="tertiary">
            {FORMAT_NOTE}
          </Typography>
        </Stack>

        <Stack className="w-full shrink-0 sm:w-64">
          <DocumentExampleList examples={category.examples} />
        </Stack>
      </Stack>
    </Card>
  );
};
